/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum Rights {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_SP_DISPATCHER = 'ROLE_SP_DISPATCHER',
  ROLE_SP_SALES_ADMIN = 'ROLE_SP_SALES_ADMIN',
  ROLE_SP_AUTO_PARK = 'ROLE_SP_AUTO_PARK',
  ROLE_USER = 'ROLE_USER',
  ROLE_SP_SALES = 'ROLE_SP_SALES',
  ROLE_CUSTOMER_ORDER = 'ROLE_CUSTOMER_ORDER',
  ROLE_SP_PLANNER = 'ROLE_SP_PLANNER',
  ROLE_CUSTOMER_ADMIN = 'ROLE_CUSTOMER_ADMIN',
  ROLE_SP_FINANCIAL = 'ROLE_SP_FINANCIAL',
  ROLE_SP_ADMIN = 'ROLE_SP_ADMIN',
  ROLE_CUSTOMER_FINANCIAL = 'ROLE_CUSTOMER_FINANCIAL',
  ROLE_DETALII_COMPANIE = 'ROLE_DETALII_COMPANIE',
  ROLE_PROFIL_COMPANIE = 'ROLE_PROFIL_COMPANIE',
  ROLE_EMAIL_AUTH = 'ROLE_EMAIL_AUTH',
  ROLE_NOTIFICATION_MONITORING = 'ROLE_NOTIFICATION_MONITORING',
  ROLE_SELECT_ITEMS_ADMIN = 'ROLE_SELECT_ITEMS_ADMIN',
  ROLE_SIGNUP = 'ROLE_SIGNUP',
  ROLE_USERS = 'ROLE_USERS',
  ROLE_ROLES = 'ROLE_ROLES',
  ROLE_SP_FORWARDING = 'ROLE_SP_FORWARDING',
  ROLE_INTERNAL = 'ROLE_INTERNAL',
  ROLE_CRM = 'ROLE_CRM',
  ROLE_ETRANSPORT = 'ROLE_ETRANSPORT',
  ROLE_ANAF_ADMIN = 'ROLE_ANAF_ADMIN',
  ROLE_ETRANSPORT_COLLAB_COMMERCIAL_PARTNER = 'ROLE_ETRANSPORT_COLLAB_COMMERCIAL_PARTNER',
  ROLE_ETRANSPORT_COLLAB_SHIPMENT_ORGANIZER = 'ROLE_ETRANSPORT_COLLAB_SHIPMENT_ORGANIZER',
  ROLE_ETRANSPORT_SHIPMENT_ORGANIZER = 'ROLE_ETRANSPORT_SHIPMENT_ORGANIZER',
  ROLE_EXTERNAL_ORDER = 'ROLE_EXTERNAL_ORDER',
  ROLE_UNEDIFACT = 'ROLE_UNEDIFACT',
  ROLE_SAFT = 'ROLE_SAFT',
  ROLE_WAREHOUSE = 'ROLE_WAREHOUSE',
  ROLE_WAREHOUSE_GATEKEEPER = 'ROLE_WAREHOUSE_GATEKEEPER',
}
